import { render, staticRenderFns } from "./ViewWrapper.vue?vue&type=template&id=53de6e39&"
import script from "./ViewWrapper.vue?vue&type=script&lang=js&"
export * from "./ViewWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports